import { PlanType } from '@labrav/react-components'

import { getDateDiff } from '../common/utils/dates'
import {
  SubscriptionObject,
  SubscriptionStatusValue,
} from '../modules/subscription/reducer'
import { ProductStatus } from '../modules/productsListing/types'

export const subscriptionDisabled = (
  planType: string,
  subscriptionStatus: string,
  productStatus?: string,
  subscriptionItem?: SubscriptionObject
) => {
  if (
    planType !== PlanType.SAAS_CONTRACT ||
    subscriptionStatus === SubscriptionStatusValue.SUBSCRIPTION_FAIL ||
    subscriptionStatus === SubscriptionStatusValue.SUBSCRIPTION_PENDING ||
    subscriptionStatus === SubscriptionStatusValue.UNSUBSCRIBE_SUCCESS ||
    productStatus === ProductStatus.PRODUCT_STATUS_RESTRICTED ||
    getDateDiff(subscriptionItem?.contractExpirationDate || '').dayDiff < 0 ||
    (subscriptionItem?.offerType === 'CPPO' &&
      subscriptionItem?.creationOrigin !== 'CP')
  ) {
    return true
  }
  return false
}

export const meteringDisabled = ({
  status,
  productType,
  entitlement,
}: SubscriptionObject): boolean => {
  if (
    status === SubscriptionStatusValue.SUBSCRIPTION_PENDING ||
    status === SubscriptionStatusValue.SUBSCRIPTION_FAIL ||
    status === SubscriptionStatusValue.UNSUBSCRIBE_SUCCESS
  ) {
    return true
  }

  if (productType === PlanType.SAAS_SUBSCRIPTION) {
    return false
  }

  return !(
    productType === PlanType.SAAS_CONTRACT &&
    entitlement?.rows.some(
      ({ dimensionIsAdditionalUsageAllowed }) =>
        dimensionIsAdditionalUsageAllowed
    )
  )
}
